import { render, staticRenderFns } from "./ArticleListComp.vue?vue&type=template&id=9c8942a8&scoped=true&"
import script from "./ArticleListComp.vue?vue&type=script&lang=js&"
export * from "./ArticleListComp.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListComp.vue?vue&type=style&index=0&id=9c8942a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8942a8",
  null
  
)

export default component.exports